import { entities } from "sb-bff-integration";
/**
 * Enum for Selection Side
 * @readonly
 * @enum {number}
 */
export var SelectionSide;
(function (SelectionSide) {
    SelectionSide[SelectionSide["Home"] = 1] = "Home";
    SelectionSide[SelectionSide["Draw"] = 2] = "Draw";
    SelectionSide[SelectionSide["Away"] = 3] = "Away";
})(SelectionSide || (SelectionSide = {}));
/**
 * @constant selectionOutcomeTypeMapper  - Helper object to map OutcomeType to SelectionSide
 */
export const selectionOutcomeTypeMapper = {
    [entities.OutcomeType.Home]: SelectionSide.Home,
    [entities.OutcomeType.Away]: SelectionSide.Away,
    [entities.OutcomeType.Over]: SelectionSide.Home,
    [entities.OutcomeType.Under]: SelectionSide.Away,
    [entities.OutcomeType.Draw]: SelectionSide.Draw,
    [entities.OutcomeType.Tie]: SelectionSide.Draw,
};
//# sourceMappingURL=selectionOutcomeTypeMapper.js.map